// Shifts its first child vertically as it scrolls through the viewport. Off with reduced motion.
class KParallax extends HTMLElement {
  connectedCallback() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    const speed = Number(this.getAttribute('speed') || 0.15);
    let frame = 0;
    let visible = false;
    const update = () => {
      const target = this.firstElementChild;
      if (!target || !visible) return;
      const rect = this.getBoundingClientRect();
      const offset = (rect.top + rect.height / 2 - innerHeight / 2) * -speed;
      target.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0)`;
    };
    this.observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      update();
    });
    this.observer.observe(this);
    addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true, signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
}

if (!customElements.get('k-parallax')) customElements.define('k-parallax', KParallax);
